import styled from '@emotion/styled'
import { SelectMenu } from 'components/patterns/Inputs'

export const StyledSelectMenu = styled(SelectMenu)`
  .ant-select {
    width: 100%;
  }
`
